import { DeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { getAvailableDays } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/getAvailableDays'
import { useMemo } from 'react'

export const useAvailableDays = (deliveryTimeOffer: DeliveryTimeOffer): string[] => {
    return useMemo(() => getAvailableDays(deliveryTimeOffer), [deliveryTimeOffer])
}
